<template>
    <base-overlay
        :is-open="showOverlay"
        @overlayClose="emitClose"
    >
        <template v-slot:header>
            <h1 class="text-center text-base font-bold">
                {{ $t('COMPONENTS') }}
                <span class="text-black opacity-50">
                    {{ visibleGroups.length }}
                </span>
            </h1>

            <reset-button />
        </template>

        <template v-slot:content>
            <ul>
                <swiper-list-item
                    v-for="(group, index) in visibleGroups"
                    :key="group"
                    :item-data="group"
                    role="button"
                    @click="openGroupOverlay(group)"
                    :class="[
                        { 'border-b border-gray': index !== visibleGroups.length - 1 },
                        { 'opacity-50': editDisabled(group.name) }
                    ]"
                    class="h-24 py-3"
                />
            </ul>

            <base-overlay
                :is-open="showGroupOverlay"
                @overlayClose="showGroupOverlay = false"
            >
                <template v-slot:header>
                    <h1
                        v-if="selectedGroup"
                        class="flex-1 text-center text-base font-bold"
                    >
                        {{ selectedGroup.name }}
                    </h1>

                    <apply-button
                        :group-name="selectedGroup?.name"
                        @click="showGroupOverlay = false"
                    />
                </template>

                <template v-slot:content>
                    <step-options
                        v-if="selectedGroup"
                        :item-data="selectedGroup"
                    />
                </template>
            </base-overlay>
        </template>
    </base-overlay>
</template>

<script>
    import allStores from '../stores/all';

    import BaseOverlay from './BaseOverlay.vue';
    import ResetButton from './ResetButton.vue';
    import SwiperListItem from './SwiperListItem.vue';
    import StepOptions from './StepOptions.vue';
    import ApplyButton from './ApplyButton.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseOverlay,
            ResetButton,
            SwiperListItem,
            StepOptions,
            ApplyButton,
        },

        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                selectedGroup: null,
                showGroupOverlay: false,
            };
        },

        computed: {
            showOverlay() {
                return this.isOpen;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.selectedGroup?.name);
            },

            disableEdit() {
                return this.customizerStore.disableEdit;
            },
        },

        methods: {
            emitClose() {
                this.$emit('overlayClose');
            },

            editDisabled(groupName) {
                return this.disableEdit && groupName !== 'Size & Width';
            },

            openGroupOverlay(group) {
                if (!this.editDisabled(group.name)) {
                    this.selectedGroup = group;
                    this.showGroupOverlay = true;
                }
            },
        },
    };
</script>
